﻿export default class ShowMessage {

    constructor()
    {
        setTimeout(()=>{this.checkArgs();}, 2000);
    }

    checkArgs()
    {
        const url = document.location.href;
        return url.indexOf('showmessage') > 0 ? this.showMessage() : false;
    }

    showMessage()
    {
        const message = document.getElementById('js-action-message');
        message.style.display = '';
    }
}

/* jshint unused: false */
const showMessageInstance = new ShowMessage();